import React, { useEffect, useState } from 'react';

/** A product photo with a neutral placeholder when the retailer image fails to load. */
const CatalogImage: React.FC<{ src: string | null; alt: string; className: string }> = ({ src, alt, className }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  if (!src || failed) {
    return (
      <div
        role="img"
        aria-label={`Photo unavailable for ${alt}`}
        className={`${className} flex items-center justify-center bg-gray-100 p-2 text-center text-[10px] leading-tight text-gray-500`}
      >
        <span>
          Photo
          <br />
          unavailable
        </span>
      </div>
    );
  }
  return <img src={src} alt={alt} className={className} loading="lazy" referrerPolicy="no-referrer" onError={() => setFailed(true)} />;
};

export default CatalogImage;
